import { I18nUtil } from "@/src/utils/i18n";
import Translations from "@/src/translate/screens/theme-pack/ThemePackConnectedContent";
import {
  buildReportDirectContextQuestion,
  encodeReportReferenceSource,
  REPORT_ASK_ED_MAX_REFERENCE_SOURCE_CHARS,
} from "@/src/screens/report/buildReportAskEdQuestion";
import { getThemePackByDataSlug } from "./themePackCatalog";

const I18n = I18nUtil.createScoped(Translations);

export function themePackSlugFromReference(
  question?: string | null,
): string | null {
  return (
    question?.match(
      /^\[[^\]\r\n]+\]\(referenceType=direct_context&referenceSource=ThemePack%3D([A-Za-z0-9_-]+)%0A[^)]+\)$/,
    )?.[1] ?? null
  );
}

export function buildThemePackChatQuestion(input: {
  slug: string;
  assets: { symbol: string; rating: string; name?: string }[];
}): string {
  const campaign = getThemePackByDataSlug(input.slug)?.[1];
  const samples = input.assets.slice(0, 3).map((asset) => ({
    ...asset,
    name: Array.from((asset.name || "").replace(/[\r\n|]/g, " ").trim()),
  }));
  const buildSource = () =>
    [
      `ThemePack=${input.slug}`,
      `Theme: ${campaign?.displayName || input.slug}`,
      "Entry: The user viewed this ranking and tapped Ed: interest, not ownership or buying intent.",
      "Purpose: Help the user understand their portfolio, even when holdings differ from this theme.",
      "Analysis: Use personal-finance/finctl to understand actual investment holdings and surface meaningful insights. The theme is a starting interest.",
      "Data: Partial ranking; no match does not mean zero theme exposure; fund exposure needs holdings evidence. Ratings=overall scores, not weights/returns; methodology unknown.",
      `Sample (${new Date().toISOString().slice(0, 10)}): ${samples
        .map(
          (asset) => `${asset.symbol}|${asset.name.join("")}|${asset.rating}`,
        )
        .join(";")}`,
    ].join("\n");
  let source = buildSource();
  while (
    encodeReportReferenceSource(source).length >
    REPORT_ASK_ED_MAX_REFERENCE_SOURCE_CHARS
  ) {
    const longest = samples.reduce<(typeof samples)[number] | undefined>(
      (result, asset) =>
        !result ||
        encodeReportReferenceSource(asset.name.join("")).length >
          encodeReportReferenceSource(result.name.join("")).length
          ? asset
          : result,
      undefined,
    );
    if (!longest?.name.length) {
      break;
    }
    longest.name.pop();
    source = buildSource();
  }
  return buildReportDirectContextQuestion(
    I18n.t("What you own, against this ranking"),
    source,
    "",
  ).trimEnd();
}
